import React, { Component } from 'react';
import './SidebarComponent.css';
import { connect } from "react-redux";
import history from "../../history";


class SidebarComponent extends Component {
    constructor(props) {
        super();
        this.state = {
            logout: false,
            sideprops: 'DB',
            isSidebarVisible: true,
        }
        this.scrollRef = React.createRef();
    }

    handleLogout = () => {
        localStorage.removeItem("token");
        history.push("/");
    }

    sideBarChange = (key) => {
        // Save scroll position before navigation so the next page's sidebar restores it.
        if (this.scrollRef.current) {
            sessionStorage.setItem('sidebarScrollTop', String(this.scrollRef.current.scrollTop));
        }
        this.setState({ sideprops: key });
    }

    handleScroll = () => {
        if (this.scrollRef.current) {
            sessionStorage.setItem('sidebarScrollTop', String(this.scrollRef.current.scrollTop));
        }
    }

    restoreScroll = () => {
        if (!this.scrollRef.current) return;
        const saved = sessionStorage.getItem('sidebarScrollTop');
        if (saved !== null) {
            this.scrollRef.current.scrollTop = parseInt(saved, 10) || 0;
            return;
        }
        // No saved scroll yet — scroll the active link into view if it's off-screen.
        const active = this.scrollRef.current.querySelector('a.nav-highligh, a.nav-highlight');
        if (active) {
            const c = this.scrollRef.current;
            const cTop = c.scrollTop;
            const cBot = cTop + c.clientHeight;
            const aTop = active.offsetTop;
            const aBot = aTop + active.offsetHeight;
            if (aTop < cTop || aBot > cBot) {
                c.scrollTop = aTop - 8;
            }
        }
    }

    componentDidMount() {
        this.setState({
            sideprops: this.props.sideProp,
            isSidebarVisible: this.props.isVisible !== undefined ? this.props.isVisible : true
        }, this.restoreScroll);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isVisible !== this.props.isVisible) {
            this.setState({ isSidebarVisible: this.props.isVisible })
        }
    }

    render() {

        let userRoleId = localStorage.getItem('userRoleId');
        let userFName = localStorage.getItem('userFirstName') || '';
        let userLName = localStorage.getItem('userLastName') || '';
        let userName = (userFName + ' ' + userLName).trim() || 'Account';
   return (
  <div className="sidebar">
    <div className="sidebar-brand">
      <img src="/img/nlogo.png" alt="Noise" className="sidebar-brand-logo" />
      <span className="sidebar-brand-label">Connect</span>
    </div>
    <div
      ref={this.scrollRef}
      onScroll={this.handleScroll}
      className={`sidebar-container ${!this.state.isSidebarVisible && window.innerWidth <= 600 ? 'd-none' : ''}`}
    >
      { userRoleId != "11" ? (
        <>
          {/* Full Sidebar */}
          <a href="/dashboard" onClick={() => this.sideBarChange('DB')} className={this.state.sideprops === 'DB' ? "nav-highligh" : ''}>
            <i className={this.state.sideprops === 'DB' ? "fa fa-th-large menucolor2" : "fa fa-th-large"}></i>
            <span className={this.state.sideprops === 'DB' ? "menucolor" : ''}>Dashboard</span>
          </a>
          <a href="/complaints-data" className={this.state.sideprops === 'CC' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('CC')}>
            <i className={this.state.sideprops === "CC" ? "fas fa-clipboard-list menucolor2" : "fas fa-clipboard-list"}></i>
            <span className={this.state.sideprops === 'CC' ? "menucolor" : ''}>Complaints</span>
          </a>
          <a href="/bose-complaints-data" className={this.state.sideprops === 'BC' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('BC')}>
            <i className={this.state.sideprops === "BC" ? "fas fa-headphones menucolor2" : "fas fa-headphones"}></i>
            <span className={this.state.sideprops === 'BC' ? "menucolor" : ''}>Master Buds</span>
          </a>
            <a href="/junior-complaints-data" className={this.state.sideprops === 'JC' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('JC')}>
            <i className={this.state.sideprops === "JC" ? "fas fa-child menucolor2" : "fas fa-child"}></i>
            <span className={this.state.sideprops === 'JC' ? "menucolor" : ''}>Noise Junior</span>
          </a>
          <a href="/rtl-data" className={this.state.sideprops === 'RD' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('RD')}>
            <i className={this.state.sideprops === 'RD' ? "fas fa-undo-alt menucolor2" : "fas fa-undo-alt"}></i>
            <span className={this.state.sideprops === 'RD' ? "menucolor" : ''}>RTL Complaints</span>
          </a>
          <a href="/home-audio" className={this.state.sideprops === 'HA' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('HA')}>
            <i className={this.state.sideprops === 'HA' ? "fas fa-volume-up menucolor2" : "fas fa-volume-up"}></i>
            <span className={this.state.sideprops === 'HA' ? "menucolor" : ''}>Home Audio</span>
          </a>
          <a href="/Sc-complaints" className={this.state.sideprops === 'SC' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('SC')}>
            <i className={this.state.sideprops === 'SC' ? "fas fa-tools menucolor2" : "fas fa-tools"}></i>
            <span className={this.state.sideprops === 'SC' ? "menucolor" : ''}>SC Complaints</span>
          </a>
          <a href="/refund" className={this.state.sideprops === 'RS' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('RS')}>
            <i className={this.state.sideprops === 'RS' ? "fa fa-rupee menucolor2" : "fa fa-rupee"}></i>
            <span className={this.state.sideprops === 'RS' ? "menucolor" : ''}>Refund</span>
          </a>
          <a href="/manage-user" className={this.state.sideprops === 'MU' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('MU')}>
            <i className={this.state.sideprops === 'MU' ? "fas fa-users-cog menucolor2" : "fas fa-users-cog"}></i>
            <span className={this.state.sideprops === 'MU' ? "menucolor" : ''}>Manage Users</span>
          </a>
          <a href="/leaderboard" className={this.state.sideprops === 'LB' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('LB')}>
            <i className={this.state.sideprops === 'LB' ? "fas fa-chart-line menucolor2" : "fas fa-chart-line"}></i>
            <span className={this.state.sideprops === 'LB' ? "menucolor" : ''}>Reports</span>
          </a>
          <a href="/manage-product" className={this.state.sideprops === 'MP' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('MP')}>
            <i className={this.state.sideprops === 'MP' ? "fas fa-box-open menucolor2" : "fas fa-box-open"}></i>
            <span className={this.state.sideprops === 'MP' ? "menucolor" : ''}>Product</span>
          </a>
          <a href="/bulk_movement" className={this.state.sideprops === 'BM' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('MB')}>
            <i className={this.state.sideprops === "BM" ? "fas fa-truck menucolor2" : "fas fa-truck"}></i>
            <span className={this.state.sideprops === 'BM' ? "menucolor" : ''}>Bulk Movement</span>
          </a>
          <a href="/warranty-data" className={this.state.sideprops === 'WD' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('WD')}>
            <i className={this.state.sideprops === 'WD' ? 'fas fa-id-card menucolor2' : 'fas fa-id-card'}></i>
            <span className={this.state.sideprops === 'WD' ? "menucolor" : ''}>Customer</span>
          </a>
          <a href="/settings" className={this.state.sideprops === 'SS' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('SS')}>
            <i className={this.state.sideprops === 'SS' ? "fa fa-cog menucolor2" : "fa fa-cog"}></i>
            <span className={this.state.sideprops === 'SS' ? "menucolor" : ''}>Settings</span>
          </a>
          <a href="/bulk-sc-complaints" className={this.state.sideprops === 'SCV' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('SCV')}>
            <i className={this.state.sideprops === 'SCV' ? "fas fa-warehouse menucolor2" : "fas fa-warehouse"}></i>
            <span className={this.state.sideprops === 'SCV' ? "menucolor" : ''}>Service Center</span>
          </a>
          {(userRoleId === '1' || userRoleId === '2') && (
            <a href="/international-tickets" className={this.state.sideprops === 'IT' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('IT')}>
              <i className={this.state.sideprops === 'IT' ? "fa fa-globe menucolor2" : "fa fa-globe"}></i>
              <span className={this.state.sideprops === 'IT' ? "menucolor" : ''}>International</span>
            </a>
          )}
        </>
      ) :
      // userRoleId == "13" ? (
      //   // Only Meesho Ticket
      //   <a href="/meesho-ticket" className={this.state.sideprops === 'MT' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('MT')}>
      //     <i className={this.state.sideprops === 'MT' ? "fa fa-ticket-alt menucolor2" : "fa fa-ticket-alt"}></i>
      //     <span className={this.state.sideprops === 'MT' ? "menucolor" : ''}>Meesho Ticket</span>
      //   </a>
      // ) :
       (
        // Only B2B Report
        <a href="/settings" className={this.state.sideprops === 'SS' ? "nav-highligh" : ''} onClick={() => this.sideBarChange('SS')}>
          <i className={this.state.sideprops === 'SS' ? "fa fa-cog menucolor2 " : "fa fa-cog"}></i>
          <span className={this.state.sideprops === 'SS' ? "menucolor" : ''}>B2B Report</span>
        </a>
      )}
    </div>
    <div className="sidebar-footer">
      <div className="sidebar-user">
        <i className="fas fa-user-circle sidebar-user-avatar"></i>
        <div className="sidebar-user-info">
          <span className="sidebar-user-name" title={userName}>{userName}</span>
          <a className="sidebar-user-profile" href="/settings" onClick={() => this.sideBarChange('SS')}>View profile</a>
        </div>
      </div>
      <button type="button" className="sidebar-logout" onClick={this.handleLogout}>
        <i className="fas fa-power-off"></i>
        <span>Logout</span>
      </button>
    </div>
  </div>
)

    }

}
const mapStateToProps = state => ({
    // user: state.user.user
    // sideProp:state.complaints.sideProp,
})


export default connect(mapStateToProps, {})(SidebarComponent);
